<div class="mb-1">
  <h4 class="headingXS">
    <strong>{{
      "VERIFY.ADDON." + addon.identifier + ".TITLE" | translate
    }}</strong>
    <span *ngIf="addon.price" class="pricedetails float-right">
      € {{ addon.price | priceFormat }}
    </span>
  </h4>
  <a
    class="link"
    [cypress]="'delete_addon'"
    (click)="delete.emit(addon)"
  >
    {{ "BUTTON.DELETE" | translate }}
  </a>
</div>
